"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./aluno-online"), exports);
__exportStar(require("./filtros"), exports);
__exportStar(require("./educador"), exports);
__exportStar(require("./relatorios"), exports);
__exportStar(require("./relatorios/diarios"), exports);
__exportStar(require("./relatorios/documentacaoOficial"), exports);
__exportStar(require("./aluno"), exports);
__exportStar(require("./alunoAutorizacaoRetirada"), exports);
__exportStar(require("./alunoDoc"), exports);
__exportStar(require("./alunoExtra"), exports);
__exportStar(require("./alunoLogin"), exports);
__exportStar(require("./alunoResponsavel"), exports);
__exportStar(require("./arquivo"), exports);
__exportStar(require("./atestado"), exports);
__exportStar(require("./atitude"), exports);
__exportStar(require("./avaCalc"), exports);
__exportStar(require("./avaCtr"), exports);
__exportStar(require("./avaliac"), exports);
__exportStar(require("./avaNota"), exports);
__exportStar(require("./avaQuestionario"), exports);
__exportStar(require("./avaSubs"), exports);
__exportStar(require("./avaTipo"), exports);
__exportStar(require("./base"), exports);
__exportStar(require("./calculoMedias"), exports);
__exportStar(require("./calculoNotas"), exports);
__exportStar(require("./categoriaAluno"), exports);
__exportStar(require("./cargaHoraria"), exports);
__exportStar(require("./categoriaOcorrencia"), exports);
__exportStar(require("./catraca/catracaControle"), exports);
__exportStar(require("./catraca/configuracaoControleAcesso"), exports);
__exportStar(require("./catraca/logCatraca"), exports);
__exportStar(require("./centroCusto"), exports);
__exportStar(require("./centroCustoLancamento"), exports);
__exportStar(require("./chat"), exports);
__exportStar(require("./chatGroup"), exports);
__exportStar(require("./classeAluno"), exports);
__exportStar(require("./cliente"), exports);
__exportStar(require("./conta"), exports);
__exportStar(require("./contaPagar"), exports);
__exportStar(require("./conteudoMinistrado"), exports);
__exportStar(require("./curso"), exports);
__exportStar(require("./dadosDispositivo"), exports);
__exportStar(require("./dashboard"), exports);
__exportStar(require("./diaAula"), exports);
__exportStar(require("./dicionar"), exports);
__exportStar(require("./documentos"), exports);
__exportStar(require("./documentosAceite"), exports);
__exportStar(require("./documentosAtribuicao"), exports);
__exportStar(require("./documentosAtribuicaoTurmas"), exports);
__exportStar(require("./documentosConfiguracoes"), exports);
__exportStar(require("./documentosFiltros"), exports);
__exportStar(require("./documentosFiltrosPerson"), exports);
__exportStar(require("./documentosGrupos"), exports);
__exportStar(require("./documentosLocal"), exports);
__exportStar(require("./documentosOperadores"), exports);
__exportStar(require("./empresa"), exports);
__exportStar(require("./escola"), exports);
__exportStar(require("./estado"), exports);
__exportStar(require("./evento"), exports);
__exportStar(require("./falta"), exports);
__exportStar(require("./faltaCtrl"), exports);
__exportStar(require("./feriado"), exports);
__exportStar(require("./fichaSaude"), exports);
__exportStar(require("./filas"), exports);
__exportStar(require("./formaPagamento"), exports);
__exportStar(require("./fornecedor"), exports);
__exportStar(require("./frequencia"), exports);
__exportStar(require("./grade"), exports);
__exportStar(require("./gradeProfessor"), exports);
__exportStar(require("./graficos"), exports);
__exportStar(require("./horario"), exports);
__exportStar(require("./horarioAula"), exports);
__exportStar(require("./horarioGrade"), exports);
__exportStar(require("./horarioPeriodo"), exports);
__exportStar(require("./horarioSerie"), exports);
__exportStar(require("./historicoEscolar"), exports);
__exportStar(require("./historicoEscolarObs"), exports);
__exportStar(require("./historicoEscolarCiclo"), exports);
__exportStar(require("./historicoEscolarGrade"), exports);
__exportStar(require("./historicoEscolarNotas"), exports);
__exportStar(require("./historicoPadrao"), exports);
__exportStar(require("./imagem"), exports);
__exportStar(require("./IIniOnlineSGE2"), exports);
__exportStar(require("./instituicao"), exports);
__exportStar(require("./IPermissao"), exports);
__exportStar(require("./Lancamento"), exports);
__exportStar(require("./legenda"), exports);
__exportStar(require("./materia"), exports);
__exportStar(require("./matricula"), exports);
__exportStar(require("./matrizCurricular"), exports);
__exportStar(require("./matrizMateria"), exports);
__exportStar(require("./matrizMateriaGrade"), exports);
__exportStar(require("./media"), exports);
__exportStar(require("./menGrupo"), exports);
__exportStar(require("./mensagem"), exports);
__exportStar(require("./mensagemArquivo"), exports);
__exportStar(require("./mensagemAtribuicao"), exports);
__exportStar(require("./mensagemAtribuicaoAluno"), exports);
__exportStar(require("./mensagemAtribuicaoLoginExtra"), exports);
__exportStar(require("./mensagemAtribuicaoProfessor"), exports);
__exportStar(require("./mensagemAtribuicaoResponsavel"), exports);
__exportStar(require("./mensagemCategoria"), exports);
__exportStar(require("./mensagemLink"), exports);
__exportStar(require("./mensagemPerguntaFormatada"), exports);
__exportStar(require("./mensagemResposta"), exports);
__exportStar(require("./mensagemRespostaAnexo"), exports);
__exportStar(require("./mensagemRespostaFormatada"), exports);
__exportStar(require("./mensagemRespostaLink"), exports);
__exportStar(require("./mensagemVisualizacao"), exports);
__exportStar(require("./mensal"), exports);
__exportStar(require("./mensBol"), exports);
__exportStar(require("./mensItem"), exports);
__exportStar(require("./modelos"), exports);
__exportStar(require("./notaDis"), exports);
__exportStar(require("./notas"), exports);
__exportStar(require("./notasRec"), exports);
__exportStar(require("./notaFiscal"), exports);
__exportStar(require("./notifications"), exports);
__exportStar(require("./ocorrencia"), exports);
__exportStar(require("./periodo"), exports);
__exportStar(require("./periodoEtapa"), exports);
__exportStar(require("./periodoGrade"), exports);
__exportStar(require("./periodoHorario"), exports);
__exportStar(require("./ponto"), exports);
__exportStar(require("./planoConta"), exports);
__exportStar(require("./produtoSerie"), exports);
__exportStar(require("./professor"), exports);
__exportStar(require("./questAlternativa"), exports);
__exportStar(require("./questGrupo"), exports);
__exportStar(require("./questionario"), exports);
__exportStar(require("./questPerGru"), exports);
__exportStar(require("./questPergunta"), exports);
__exportStar(require("./questResposta"), exports);
__exportStar(require("./rematricula"), exports);
__exportStar(require("./rematriculaProduto"), exports);
__exportStar(require("./retPag"), exports);
__exportStar(require("./s3"), exports);
__exportStar(require("./Saldo"), exports);
__exportStar(require("./serie"), exports);
__exportStar(require("./sistemaAvaliacao"), exports);
__exportStar(require("./tag"), exports);
__exportStar(require("./tipoDesc"), exports);
__exportStar(require("./tipoOcorrencia"), exports);
__exportStar(require("./transporteEscolar"), exports);
__exportStar(require("./turma"), exports);
__exportStar(require("./turmaDis"), exports);
__exportStar(require("./turno"), exports);
__exportStar(require("./usuario"), exports);
__exportStar(require("./visita"), exports);
__exportStar(require("./webhook"), exports);
__exportStar(require("./cobranca"), exports);
__exportStar(require("./juno"), exports);
__exportStar(require("./iugu"), exports);
__exportStar(require("./bancoBrasil"), exports);
__exportStar(require("./fintech"), exports);
__exportStar(require("./integrationLog"), exports);
__exportStar(require("./irmao"), exports);
